import { Directive, ElementRef, AfterViewInit } from '@angular/core';
 
@Directive({
  selector: '[inputAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
 
  constructor(private el: ElementRef) { }
 
  ngAfterViewInit() {
    setTimeout(() => {
        const inputElement = this.el.nativeElement.querySelector('input');
        if (inputElement) {
          inputElement.focus();
        }
      }, 0);
  }
}